import { useQuery } from '@tanstack/react-query';
import { fetchTransportationGroupsList } from '@views/screens/common/data-provider/transportation-groups-list';

export const useGetTransportationGroupsList = () => {
  return useQuery({
    queryKey: ['transportation-groups-list'],
    queryFn: () => fetchTransportationGroupsList(),
    staleTime: Number.POSITIVE_INFINITY,
  });
};
